import React, { useState, useEffect } from 'react'
import { AddContainer, SittingOneBox, SittingText, Status, StatusContainer, Component4, StatusIcon, LinkText, Component3, Texts, HeaderPart, FooterPart } from './Style'
import { ReactComponent as TickCircle } from '../../../../../assets/images/tick-circle.svg';
import DialogBox from 'src/components/shared/Dialog/DialogBox';
import DateTimePicker from 'src/components/App/DatePicker/index.js';
import { palette, shadows } from 'src/config/theme';
import { ReactComponent as CloseIcon } from '../../../../../../src/assets/images/close-circle.svg';
import { ReactComponent as AddIcon } from '../../../../../../src/assets/images/add-square.svg';
import ButtonComponent from 'src/components/shared/Button';
import { alpha } from '@mui/material';
import useResponsive from 'src/components/hooks/useResponsive';
import useAppointmentDetails from "../../UseAppointmentDetails";
import { getAppointmentByPatientIdRequest } from "src/modules/app/store/appActions";
import { useDispatch, useSelector } from "react-redux";
import storage from 'src/utils/storageUtils';
import { updateRecordStatusRequest, getTreatmentByIdRequest, postTreatmentRequest } from 'src/modules/app/store/appActions';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import dayjs from 'dayjs';
import toast from 'src/utils/toast';




function TypeSitting({ onClose, treatmentName, treatmentId, fetchTreatments }) {


    const { isMobile, isTablet, isDesktop } = useResponsive();
    const dispatch = useDispatch();
    const { PatientId, clinicId, user } = useAppointmentDetails();
    const [completedAppointments, setCompletedAppointments] = useState([]);
    const [tokenAppointment, setTokenAppointment] = useState(null);

    const [appointments, setAppointments] = useState([]);
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [treatmentSchedule, setTreatmentSchedule] = useState({
        date: null,
        time: null,
    });
    const handleScheduleChange = (key, value) => {
        setTreatmentSchedule((prev) => ({
            ...prev,
            [key]: value,
        }));
    };
    const formatTime = (time) => {
        if (typeof time === 'string' && !time.includes('T')) return time;
        try {
            const dateObj = new Date(time);
            return dateObj.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
        } catch (e) {
            return 'Invalid Time';
        }
    };
    useEffect(() => {
        const fetchData = async () => {
            const response = await new Promise((resolve, reject) => {
                dispatch(getTreatmentByIdRequest(treatmentId, resolve, reject))
            })
            console.log("filtered response of Treatment scheduled", response.treatment);
            if (response.treatment.appointmentStatus === "Treatment Scheduled") {
                setAppointments(response.treatment);
                setTokenAppointment(response.treatment.tokenAppointment);
            } else {
                console.error("Expected an array but got:", response);
            }

        }
        fetchData();

    }, [dispatch, treatmentId])



    const handleStatusClick = (appointmentId) => {
        const updatedStatusData = { recordStatus: 'Complete' };

        const promise = new Promise((resolve, reject) => {
            dispatch(updateRecordStatusRequest(tokenAppointment, updatedStatusData, resolve, reject));
        });

        promise
            .then((response) => {
                console.log("Status update success:", response);
                setCompletedAppointments((prev) => [...prev, appointmentId]);
            })
            .catch((error) => {
                console.error("Status update failed:", error);
            });
    };





    const validationSchema = Yup.object().shape({

        date: Yup.date().required('treatment date is required'),
        time: Yup.date().required('Time slot is required').typeError('Please select a valid time slot'),
    });

    const handleSubmit = async (values, { resetForm }) => {
        const formattedTime = dayjs(values.time).format('HH:mm');
        const remaining = Number(appointments.remaining);
        try {
            const treatmentData = {
                treatmentType: 'sitting',
                name: appointments.name,
                total: appointments.total,
                remaining: remaining,

                dateTimes: [
                    {
                        date: values.date,
                        time: formattedTime,
                    },
                ],
                tokenAppointment: tokenAppointment,
                patient: PatientId,
                clinic: clinicId,
                user,
            }
            const response = await new Promise((resolve, reject) => {
                dispatch(postTreatmentRequest(treatmentData, resolve, reject));
            });
            console.log("treatment response here", response);
            if (response?.id && fetchTreatments) {
                fetchTreatments();
            }
            toast.success(response.message || 'Treatment Created Successfully')

            resetForm();
            onClose();

        }
        catch (error) {
            console.log(error.message || 'Failed to add notes', { variant: 'error' });
        }

    }





    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={{

                    time: dayjs(),
                    date: dayjs(),
                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ values, errors, touched, handleBlur, handleSubmit, handleChange, setFieldValue }) => (
                    <Form>

                        <HeaderPart>
                            {treatmentName ? `${treatmentName} Treatments` : 'Sitting Treatments'}

                            <CloseIcon width={isMobile || isTablet ? 18 : 24}
                                height={isMobile || isTablet ? 18 : 24} onClick={onClose} style={{ cursor: 'pointer' }} />
                        </HeaderPart>
                        <AddContainer>
                            <Component4 sx={{ gap: '6px' }}>
                                {appointments?.dateTimes?.map((dt, idx) => (
                                    <SittingOneBox key={idx}>
                                        <SittingText>
                                            {new Date(dt.date).toLocaleDateString('en-GB', {
                                                day: '2-digit',
                                                month: 'short',
                                                year: 'numeric',
                                            })}, {formatTime(dt.time)}
                                        </SittingText>

                                        <StatusContainer>
                                            <Status
                                                label={
                                                    completedAppointments.includes(appointments.id)
                                                        ? 'Complete'
                                                        : appointments.appointmentStatus
                                                }
                                                sx={{
                                                    background: completedAppointments.includes(appointments.id)
                                                        ? 'linear-gradient(0deg, rgba(57, 150, 57, 0.18), rgba(57, 150, 57, 0.18))'
                                                        : 'linear-gradient(0deg, rgba(150, 57, 150, 0.12) 0%, rgba(150, 57, 150, 0.12) 100%), #FFF',
                                                    color: completedAppointments.includes(appointments.id)
                                                        ? palette.action.green
                                                        : palette.action.purpleDark,
                                                }}
                                            />
                                            {!completedAppointments.includes(appointments.id) && (
                                                <StatusIcon
                                                    onClick={() => handleStatusClick(appointments.id)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <TickCircle />
                                                </StatusIcon>
                                            )}
                                        </StatusContainer>
                                    </SittingOneBox>
                                ))}
                            </Component4>
                            <Component4>
                                <SittingOneBox>
                                    <LinkText onClick={handleOpen}>
                                        Schedule Second Sitting
                                    </LinkText>
                                </SittingOneBox>
                            </Component4>

                            <DialogBox open={open} onClose={handleClose} >
                                <HeaderPart>
                                    Schedule Second Sitting
                                    <CloseIcon width={isMobile || isTablet ? 18 : 24}
                                        height={isMobile || isTablet ? 18 : 24} onClick={onClose} style={{ cursor: 'pointer' }} />
                                </HeaderPart>
                                <AddContainer>
                                    <Component3>
                                        <Texts>Second Treatment Date</Texts>
                                        <DateTimePicker
                                            name="date"
                                            value={values.date}
                                            onChange={(value) => setFieldValue('date', value)}
                                            fullWidth
                                            type="date"
                                            sx={{
                                                height: "52px",
                                                borderRadius: '12px',
                                                // padding: '10px 16px',
                                            }}
                                        />
                                    </Component3>
                                    <Component3>
                                        <Texts>Second Treatment Time slot</Texts>
                                        <DateTimePicker
                                            name="time"
                                            value={values.time}
                                            onChange={(value) => setFieldValue('time', value)}
                                            type="time"
                                        />

                                    </Component3>
                                </AddContainer>
                                <FooterPart >
                                    <ButtonComponent
                                        variant="none"
                                        startIcon={<CloseIcon width={isMobile || isTablet ? 18 : 24}
                                            height={isMobile || isTablet ? 18 : 24} sx={{ color: palette.primary.main }} />}
                                        onClick={onClose}
                                    >
                                        Cancel
                                    </ButtonComponent>
                                    <ButtonComponent
                                        type="submit"
                                        onClick={() => handleSubmit()}
                                        variant="outlined"
                                        startIcon={<AddIcon sx={{ color: palette.primary.main }} />}
                                        sx={{
                                            width: '104px',
                                            height: '52px',
                                            borderRadius: '12px',
                                            padding: '10px 18px',
                                            bgcolor: palette.primary.main,
                                            boxShadow: shadows[1],
                                            border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                            color: palette.gery.white,
                                            '&:hover': { color: palette.primary.main },
                                        }}
                                    // onClick={handleSubmit ? () => handleSubmit() : null}
                                    >
                                        Save
                                    </ButtonComponent>
                                </FooterPart>
                            </DialogBox>
                        </AddContainer>
                        <FooterPart >
                            <ButtonComponent
                                variant="none"
                                startIcon={<CloseIcon width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} sx={{ color: palette.primary.main }} />}
                                onClick={onClose}
                            >
                                Cancel
                            </ButtonComponent>
                            <ButtonComponent
                                type="submit"
                                variant="outlined"
                                startIcon={<AddIcon width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} sx={{ color: palette.primary.main }} />}
                                sx={{
                                    width: '104px',
                                    height: '52px',
                                    borderRadius: '12px',
                                    padding: '10px 18px',
                                    bgcolor: palette.primary.main,
                                    boxShadow: shadows[1],
                                    border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                    color: palette.gery.white,
                                    '&:hover': { color: palette.primary.main },
                                }}
                            // onClick={handleSubmit ? () => handleSubmit() : null}
                            >
                                Save
                            </ButtonComponent>
                        </FooterPart>

                    </Form>
                )}
            </Formik >
        </>
    )
}

export default TypeSitting;
